var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVipIconXmeeting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "var(--header, #2B2B2B)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.429 6.5l-3.804 5.102 11.08 11.377 11.67-11.377L20.614 6.5H5.429z",
    fill: "var(--featured-primary, #FED700)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.322 16.142v-6.88h2.596c.457 0 .806.022 1.047.065.337.057.62.165.849.324.229.157.412.377.55.662.14.285.21.598.21.939 0 .585-.186 1.08-.558 1.488-.372.403-1.045.605-2.018.605h-1.765v2.797h-.91zm.91-3.609h1.78c.588 0 1.006-.11 1.253-.328.247-.22.37-.528.37-.925 0-.288-.073-.534-.22-.737a1.007 1.007 0 00-.572-.408c-.154-.04-.437-.061-.85-.061h-1.76v2.46zM12.8 16.142v-6.88h.911v6.88h-.91zM8.201 16.142l-2.666-6.88h.986l1.788 4.998c.144.4.264.776.361 1.127.107-.376.23-.751.371-1.127L10.9 9.262h.93l-2.695 6.88h-.934z",
    fill: "var(--header, #2B2B2B)"
  })));
}
export default SvgVipIconXmeeting;